/******************************************************************************************
 *	Team Members Service
 *******************************************************************************************/
(function() {
  

  angular.module('rcServices.teamMembers', []).service(
    'TeamMembers',
    /* @ngInject */
    function($q, DemoMode, jilResellerMembers, MiniJil, User) {
      //Get reseller team members
      this.get = function(onlyActive) {
        if (DemoMode.isEnabled()) {
          const data = MiniJil.getTeamMembers(onlyActive);
          if (data) {
            return $q.resolve(data);
          } else {
            return $q.reject({
              data: {},
              status: 404
            });
          }
        } else {
          return jilResellerMembers.resellerMembers.query({
            memberId: onlyActive ? 'active' : undefined,
            resellerId: User.getResellerID()
          }).$promise;
        }
      };

      //Invite new team members to join the reseller organization
      this.invite = function(emails) {
        if (DemoMode.isEnabled()) {
          const data = MiniJil.inviteTeamMember(emails);
          if (data) {
            return $q.resolve(data);
          } else {
            return $q.reject({
              data: {},
              status: 400
            });
          }
        } else {
          return jilResellerMembers.resellerMembers.save({resellerId: User.getResellerID()}, emails)
            .$promise;
        }
      };

      //Remove reseller team member
      this.remove = function(memberId) {
        if (DemoMode.isEnabled()) {
          if (MiniJil.removeTeamMember(memberId)) {
            return $q.resolve();
          } else {
            return $q.reject({
              data: {},
              status: 403
            });
          }
        } else {
          return jilResellerMembers.resellerMembers.delete({
            memberId,
            resellerId: User.getResellerID()
          }).$promise;
        }
      };

      //Cancel invitation for reseller team member
      this.cancelInvitation = function(invitationCode) {
        if (DemoMode.isEnabled()) {
          if (MiniJil.cancelTeamMemberInvitation(invitationCode)) {
            return $q.resolve();
          } else {
            return $q.reject({
              data: {},
              status: 403
            });
          }
        } else {
          return jilResellerMembers.resellerMemberInvitations.delete({
            invitationCode,
            resellerId: User.getResellerID()
          }).$promise;
        }
      };
    }
  );
})();
